import { BrowserRouter } from "react-router-dom";
import { useState } from "react";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import MaintenancePage from "./pages/MaintenancePage";

const MAINTENANCE_BYPASS_MARKER = "tvojgym_service_access";
const maintenanceAdminCode = String(import.meta.env.VITE_MAINTENANCE_ADMIN_CODE ?? "");
const maintenanceEnabled = ["1", "true", "yes", "on"].includes(
  String(import.meta.env.VITE_MAINTENANCE_MODE ?? "").toLowerCase()
);

function App() {
  const [maintenanceBypass, setMaintenanceBypass] = useState(getInitialMaintenanceBypass);

  const handleMaintenanceUnlock = (code: string) => {
    if (!maintenanceEnabled || code !== maintenanceAdminCode) {
      return false;
    }

    persistMaintenanceBypass();
    setMaintenanceBypass(true);
    return true;
  };

  if (maintenanceEnabled && !maintenanceBypass) {
    return <MaintenancePage onUnlock={handleMaintenanceUnlock} />;
  }

  return (
    <>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
      </I18nextProvider>
    </>
  );
}

function getInitialMaintenanceBypass() {
  if (!maintenanceEnabled || typeof window === "undefined") {
    return false;
  }

  const hasCookieMarker = document.cookie
    .split("; ")
    .some((cookie) => cookie === `${MAINTENANCE_BYPASS_MARKER}=1`);

  if (hasCookieMarker) {
    return true;
  }

  try {
    return window.localStorage.getItem(MAINTENANCE_BYPASS_MARKER) === "1";
  } catch {
    return false;
  }
}

function persistMaintenanceBypass() {
  document.cookie = `${MAINTENANCE_BYPASS_MARKER}=1; Path=/; Max-Age=28800; SameSite=Lax`;

  try {
    window.localStorage.setItem(MAINTENANCE_BYPASS_MARKER, "1");
  } catch {}
}

export default App;
